/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Safe_Best_Manatee_TearInputs */

const fr_safe_best_manatee_tear = /** @type {(inputs: Safe_Best_Manatee_TearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retrouvez toutes les séances que tu as crées.`)
};

/**

* @param {Safe_Best_Manatee_TearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const safe_best_manatee_tear = /** @type {((inputs?: Safe_Best_Manatee_TearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Safe_Best_Manatee_TearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_safe_best_manatee_tear(inputs)
});